import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentList12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconDocumentList12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.917 1H2.5a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V5.083H5.917zm3.958 3.083a1 1 0 0 0-.197-.25l-2.761-2.55v2.8zM2.5 12h7a1.5 1.5 0 0 0 1.5-1.5V4.568a2 2 0 0 0-.643-1.47L7.575.53A2 2 0 0 0 6.218 0H2.5A1.5 1.5 0 0 0 1 1.5v9A1.5 1.5 0 0 0 2.5 12m3-4.5A.5.5 0 0 1 6 7h2a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5M6 9a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM4.5 7.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M4 10a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentList12);
